import React, { useState, useEffect } from 'react';
import {
  getFirestore,
  collection,
  getDocs,
  doc,
  updateDoc
} from 'firebase/firestore';
import app from "../../firebaseConfig";

const db = getFirestore(app);

const AdminRentals = () => {
  const [cars, setCars] = useState([]);
  const [trips, setTrips] = useState([]);
  const [selectedCar, setSelectedCar] = useState(null);
  const [carForm, setCarForm] = useState({});
  const [addOnsConfig, setAddOnsConfig] = useState({
    delivery: 50,
    refuel: 25,
    boosterSeat: 10,
  });

  useEffect(() => {
    const fetchCarsAndTrips = async () => {
      const carsSnapshot = await getDocs(collection(db, 'cars'));
      const carsData = carsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setCars(carsData);

      const tripsSnapshot = await getDocs(collection(db, 'trips'));
      const tripsData = tripsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setTrips(tripsData);
    };
    fetchCarsAndTrips();
  }, []);

  const handleCarSelect = (car) => {
    setSelectedCar(car);
    setCarForm({ pricePerDay: car.pricePerDay, availability: car.availability ?? true });
  };

  const handleCarChange = (field, value) => {
    setCarForm(prev => ({ ...prev, [field]: value }));
  };

  const handleCarSave = async () => {
    if(selectedCar) {
      const carRef = doc(db, 'cars', selectedCar.id);
      await updateDoc(carRef, { ...carForm });
      alert('Car updated successfully');
      // Optionally refresh car list or update local state
    }
  };

  const handleAddOnsChange = (addOn, value) => {
    setAddOnsConfig(prev => ({ ...prev, [addOn]: value }));
  };

  const handleAddOnsSave = () => {
    // Save logic for add-ons can be implemented here if required.
    alert('Add-Ons configuration saved');
  };

  const handleApproveID = async (tripId) => {
    const tripRef = doc(db, 'trips', tripId);
    await updateDoc(tripRef, { idApproved: true });
    alert('ID Approved');
  };

  const handleDenyID = async (tripId) => {
    const tripRef = doc(db, 'trips', tripId);
    await updateDoc(tripRef, { idApproved: false });
    alert('ID Denied - User should re-upload.');
  };

  const handleApproveInsurance = async (tripId) => {
    const tripRef = doc(db, 'trips', tripId);
    await updateDoc(tripRef, { insuranceApproved: true });
    alert('Insurance Approved');
  };

  const handleDenyInsurance = async (tripId) => {
    const tripRef = doc(db, 'trips', tripId);
    await updateDoc(tripRef, { insuranceApproved: false });
    alert('Insurance Denied - User should re-upload.');
  };

  // Stub functions for trip management actions
  const handleCancelTrip = (tripId) => alert(`Cancel trip ${tripId}`);
  const handleRefundTrip = (tripId) => alert(`Refund trip ${tripId}`);
  const handleEditTrip = (tripId) => alert(`Edit trip ${tripId}`);

  return (
    <div style={{ padding: '20px' }}>
      <h1>Admin Dashboard</h1>
      
      {/* Car Configuration Section */}
      <section style={{ marginBottom: '40px' }}>
        <h2>Car Configuration</h2>
        <div style={{ display: 'flex', gap: '20px' }}>
          
          {/* Cars List */}
          <div style={{ flex: 1 }}>
            <h3>Cars List</h3>
            {cars.map(car => (
              <div
                key={car.id}
                style={{
                  border: '1px solid #ccc',
                  marginBottom: '10px',
                  padding: '10px',
                  cursor: 'pointer'
                }}
                onClick={() => handleCarSelect(car)}
              >
                <p>{car.carName}</p>
              </div>
            ))}
          </div>
          
          {/* Selected Car Edit Form */}
          <div style={{ flex: 2 }}>
            {selectedCar && (
              <div>
                <h3>Edit Car: {selectedCar.carName}</h3>
                <label>
                  Price per Day:
                  <input
                    type="number"
                    value={carForm.pricePerDay}
                    onChange={(e) => handleCarChange('pricePerDay', parseFloat(e.target.value))}
                  />
                </label>
                <br />
                <label>
                  Availability:
                  <select
                    value={carForm.availability}
                    onChange={(e) => handleCarChange('availability', e.target.value === 'true')}
                  >
                    <option value="true">Available</option>
                    <option value="false">Unavailable</option>
                  </select>
                </label>
                <br />
                <button onClick={handleCarSave}>Save</button>
              </div>
            )}
          </div>
        </div>

        {/* Add-Ons Configuration */}
        <div style={{ marginTop: '20px' }}>
          <h3>Configure Add-Ons Pricing</h3>
          {Object.keys(addOnsConfig).map(addOn => (
            <div key={addOn}>
              <label>
                {addOn}: 
                <input
                  type="number"
                  value={addOnsConfig[addOn]}
                  onChange={(e) => handleAddOnsChange(addOn, parseFloat(e.target.value))}
                />
              </label>
            </div>
          ))}
          <button onClick={handleAddOnsSave}>Save Add-Ons</button>
        </div>
      </section>

      {/* Trips Management Section */}
      <section>
        <h2>Trips Management</h2>
        {trips.map(trip => (
          <div
            key={trip.id}
            style={{ border: '1px solid #ddd', padding: '10px', marginBottom: '10px' }}
          >
            <p><strong>User:</strong> {trip.userName}</p>
            <p><strong>Car:</strong> {trip.carName}</p>
            <p><strong>Payment Amount:</strong> ${trip.paymentAmount}</p>
            <p><strong>Rental Days:</strong> {trip.rentalDays}</p>
            {trip.addOns && trip.addOns.includes('delivery') && (
              <p><strong>Delivery Address:</strong> {trip.deliveryAddress}</p>
            )}

            <div>
              <h4>ID and Insurance Verification</h4>
              {trip.idFileUrl && (
                <div>
                  <p>ID Document:</p>
                  <img src={trip.idFileUrl} alt="User ID" style={{ maxWidth: '200px' }}/>
                  <div>
                    <button onClick={() => handleApproveID(trip.id)}>Approve ID</button>
                    <button onClick={() => handleDenyID(trip.id)}>Deny ID</button>
                  </div>
                </div>
              )}
              {trip.insuranceFileUrl && (
                <div>
                  <p>Insurance Document:</p>
                  <img src={trip.insuranceFileUrl} alt="Insurance" style={{ maxWidth: '200px' }}/>
                  <div>
                    <button onClick={() => handleApproveInsurance(trip.id)}>Approve Insurance</button>
                    <button onClick={() => handleDenyInsurance(trip.id)}>Deny Insurance</button>
                  </div>
                </div>
              )}
            </div>

            <div style={{ marginTop: '10px' }}>
              <button onClick={() => handleCancelTrip(trip.id)}>Cancel Trip</button>
              <button onClick={() => handleRefundTrip(trip.id)}>Refund Trip</button>
              <button onClick={() => handleEditTrip(trip.id)}>Edit Trip</button>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
};

export default AdminRentals;
